import { connect } from "react-redux";
import { NAMESPACE } from "./constants";
import PopupMessage from "./popupMessage";
import actions from "./redux/actionCreators";
const mapStateToProps = (state) => ({
    messages: state[NAMESPACE].messages
});
const mapDispatchToProps = (dispatch) => ({
    onProcessed: (ids) => dispatch(actions.cleanMessages(ids))
});
export default connect(mapStateToProps, mapDispatchToProps)(PopupMessage);
